var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFrequency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38.886,
    height: 38.883,
    viewBox: "0 0 38.886 38.883",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    width: 38.886,
    height: 38.883,
    fill: "#c4e7f8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-frequency",
    transform: "translate(-5.825 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395",
    transform: "translate(5.825 -0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M22.8,13.016a9.714,9.714,0,1,0-9.714,9.714A9.715,9.715,0,0,0,22.8,13.016",
    transform: "translate(6.568 6.443)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M19.446,38.882A19.442,19.442,0,1,1,19.446,0a2.929,2.929,0,1,1,0,5.857A13.586,13.586,0,1,0,33.023,19.442a2.932,2.932,0,0,1,5.863,0,19.463,19.463,0,0,1-19.44,19.44",
    transform: "translate(0 0)",
    fill: "#c4e7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M18.013,13.27a2.928,2.928,0,0,1-2.573-1.529A13.544,13.544,0,0,0,9.748,6.149a2.93,2.93,0,0,1,2.7-5.2,19.475,19.475,0,0,1,8.135,7.994,2.931,2.931,0,0,1-1.171,3.972,2.985,2.985,0,0,1-1.4.354",
    transform: "translate(15.939 1.22)",
    fill: "#c4e7f8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFrequency);
export default __webpack_public_path__ + "static/media/icon-frequency.6a55894a3a3d628faa4eb64ccc0698d7.svg";
export { ForwardRef as ReactComponent };